import { MotionConfig } from "framer-motion";
import * as React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { CardFlightProvider } from "@/components/CardFlight";
import { CardSkeleton } from "@/components/CardDisplay";
import { Layout } from "@/components/Layout";
import { Toaster } from "@/components/ui/sonner";
import { Skeleton } from "@/components/ui/skeleton";
import { TooltipProvider } from "@/components/ui/tooltip";

const LandingPage = React.lazy(() => import("@/pages/LandingPage"));
const DeckBuilder = React.lazy(() => import("@/pages/DeckBuilder"));
const DeckResult = React.lazy(() => import("@/pages/DeckResult"));
const ImportDeckWizard = React.lazy(() => import("@/pages/ImportDeckWizard"));

function PageSkeleton() {
  return (
    <div className="container space-y-8 py-14" aria-busy="true" aria-label="Loading">
      <Skeleton className="mx-auto h-12 w-2/3 max-w-xl" />
      <Skeleton className="mx-auto h-5 w-1/2 max-w-md" />
      <div className="grid grid-cols-2 gap-5 sm:grid-cols-3 lg:grid-cols-5">
        {Array.from({ length: 5 }, (_, index) => (
          <CardSkeleton key={index} />
        ))}
      </div>
    </div>
  );
}

function lazyPage(Page: React.LazyExoticComponent<() => React.JSX.Element>) {
  return (
    <React.Suspense fallback={<PageSkeleton />}>
      <Page />
    </React.Suspense>
  );
}

const router = createBrowserRouter([
  {
    element: <Layout />,
    children: [
      { path: "/", element: lazyPage(LandingPage) },
      { path: "/build", element: lazyPage(DeckBuilder) },
      { path: "/import", element: lazyPage(ImportDeckWizard) },
      { path: "/deck", element: lazyPage(DeckResult) },
      { path: "/d/:deckSeed", element: lazyPage(DeckResult) },
      { path: "*", element: lazyPage(LandingPage) },
    ],
  },
]);

export default function App() {
  return (
    <MotionConfig reducedMotion="user">
      <TooltipProvider delayDuration={200}>
        <CardFlightProvider>
          <RouterProvider router={router} />
          <Toaster />
        </CardFlightProvider>
      </TooltipProvider>
    </MotionConfig>
  );
}
